import { Environment } from '@hudl/uniform-ui-components';
import React, { ReactNode } from 'react';
import BackButton from './BackButton';
import BackgroundAngles from './BackgroundAngles';
import * as styles from './styles.scss';

interface PageBackgroundProps {
  children: ReactNode;
  environment: 'dark' | 'light';
  backButton?: {
    text?: string;
    href?: string;
    onClick?: () => void;
  };
  hideAngles?: boolean;
}

const PageBackground = ({ children, environment, backButton, hideAngles }: PageBackgroundProps) => (
  <Environment environment={environment} className={styles.hideOverflow}>
    { !hideAngles && <BackgroundAngles environment={environment} /> }

    {backButton && (
      <BackButton
        environment={environment}
        text={backButton.text}
        href={backButton.href}
        onClick={backButton.onClick}
      />
    )}

    <div className={`${styles.pageContainer} ${!hideAngles ? "pad" : ""}`}>{children}</div>
  </Environment>
);

export default PageBackground;
